<template>
  <div>
    <greet></greet>
    <red-separator></red-separator>
    <screenshots></screenshots>
    <features></features>
    <play></play>
    <micro-blog></micro-blog>
    <subscription></subscription>
  </div>
</template>
<script>
import Subscription from "../partials/Subscription/Subscription.vue";
import Features from "../partials/Home/Features.vue";
import Play from "../partials/Home/Play.vue";
import Greet from "../partials/Home/Greet.vue";
import RedSeparator from "../partials/Home/RedSepartor.vue";
import MicroBlog from "../partials/Blog/MicroBlog.vue";
import Screenshots from "../partials/Home/Screenshots.vue";

export default {
  components: {
    subscription: Subscription,
    "micro-blog": MicroBlog,
    features: Features,
    play: Play,
    "red-separator": RedSeparator,
    greet: Greet,
    screenshots: Screenshots
  },
  data() {
    return {};
  }
};
</script>
